import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import DOMPurify from 'dompurify';
import useConvertTex from 'hooks/API/POST/useConvertTex';
import { useEffect } from 'react';
import { typesetMath, unwrapMathFromPre } from 'utilities/mathjax.service';

function EditorPreview({ closeModal, open, editorData = {} }) {
  const { isLoading, mutate, isError, data } = useConvertTex();

  useEffect(() => {
    if (editorData?.value) mutate({ text: editorData.value });
  }, []);

  useEffect(() => {
    if (data?.data) {
      const node = document.querySelector('#MATH-CONTENT-AREA');
      typesetMath(node);
    }
  }, [data?.data]);

  return (
    <AppModal
      open={open}
      closeModal={() => {
        closeModal();
      }}
      popUpProps={{
        contentStyle: {
          height: '90vh',
          width: '95%',
        },
      }}
    >
      <AppModalHeader>Preview modal</AppModalHeader>
      <AppModalBody>
        <div
          className="ck-content"
          style={{
            padding: '0 16px',
          }}
        >
          {isLoading ? (
            'Loading...'
          ) : isError ? (
            'Failed to load preview data. Please try again'
          ) : data?.data ? (
            // domParser.parseFromString(data?.data, 'text/html')
            <div
              id="MATH-CONTENT-AREA"
              dangerouslySetInnerHTML={{
                __html: unwrapMathFromPre(DOMPurify.sanitize(data?.data)),
              }}
            ></div>
          ) : (
            'No data available'
          )}
        </div>
        <div className="d-flex justify-content-center">
          <AppButton
            variantClass="btn-plane p--tint my-4"
            onClick={() => {
              closeModal();
            }}
          >
            Close
          </AppButton>
        </div>
      </AppModalBody>
      <AppModalFooter></AppModalFooter>
    </AppModal>
  );
}

export default EditorPreview;
